import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router';
import {ReactComponent as CloseButton} from '../assets/svg/close-button.svg';
import {getCategories} from "../apis/category";
import {TCategory} from "../types/types";
import { MobileCategoryItem } from '../components/MobileCategoryItem';
import { Bridge } from '../plugins/bridge';
import { ContentTabEventProperties } from '../types/amplitudeEventProperties';
import { BRAZE_EVENT } from '../constants/braze';
import ReactCountryFlag from "react-country-flag";
import {ReactComponent as SgFlag} from "../assets/svg/sgFlag.svg";
import {useCookies} from "react-cookie";
import {ReactComponent as BackIcon} from "../assets/svg/backbutton-icon.svg";

const exCategories = [
    {text: '룩북', path: '/lookbook'},
    {text: '기사', path: '/journal'},
    {text: '매장', path: '/store'},
    {text: '브랜드', path: '/one-brand'},
]

export const MobileCategoryPage = () => {
    const {goBack, push} = useHistory();
    const [categories, setCategories] = useState<TCategory[]>([])
    const [showItn, setShowItn] = useState(false);
    const [cookies] = useCookies();
    const [isApp, setIsApp] = useState<boolean>(true);
    useEffect(() => {
        /*getAppClient().then(r => {
            setIsApp(Boolean(r.data));
        })*/
        if (!!!cookies['request-client'] && navigator.userAgent.indexOf('!!!IN APP EVENT!!!') === -1) {
            setIsApp(false);
        } else {
            setIsApp(true);
        }
    }, []);
    const itnClick = () => {
        setShowItn(!showItn);
    };
    useEffect(() => {
        getCategories().then(r => setCategories(r.data.payload)).catch(e => console.log(e))
    }, [])
    const redirectToLink = (url: string) => {
        window.open(url, '_blank');
    };
    function onClickContent(content: string) {
        const contentEventProperties: ContentTabEventProperties = {
          content_tab: content
        }
        Bridge.sendAmplitude('content_menu_clicked', contentEventProperties);
        Bridge.sendBraze(BRAZE_EVENT.CONTENT_MENU_CLICKED, contentEventProperties);

      }

    return (
        <>
            <div className="border-b -mx-4 flex justify-between text-14">
                <p className="px-4 py-4">{showItn ? '칼하트윕 글로벌':'카테고리'}</p>
                <div className={`flex`}>
                    {!isApp &&
                        <>
                            <button
                                onClick={itnClick}
                                className={`wh-14 grid place-content-center border-l ${showItn && 'bg-gray-100'}`}>
                                <div className={`flex items-center justify-center rounded-full overflow-hidden wh-5 relative ${!showItn && 'bg-white'}`}>
                                    {showItn ?
                                    (
                                        <div className={`fill-black`}>
                                            <BackIcon />
                                        </div>
                                    ) : (
                                        <ReactCountryFlag
                                            countryCode="KR"
                                            style={{
                                                width: '22px',
                                                height: '22px',
                                                position: 'absolute',
                                                maxWidth: '50px',
                                            }}
                                            aria-label="United States"
                                            svg
                                        />
                                    )}
                                </div>
                            </button>
                            {showItn && (
                                <div className={`absolute right-0 top-14 bg-white z-10 text-gray-800 w-full flex flex-col border h-full`}>
                                    {/*<h3 className={`py-4 text-center text-14 border-b`}>칼하트윕 글로벌</h3>*/}
                                    <ul className={`overflow-y-scroll no-scrollbar`}>
                                        <li onClick={() => redirectToLink('https://www.carhartt-wip.com/')}
                                            className={`py-4 pl-3 flex items-center gap-x-4 border-b cursor-pointer hover:bg-gray-50`}>
                                            <div className={`flex items-center justify-center rounded-full overflow-hidden wh-5 relative bg-white`}>
                                                <ReactCountryFlag
                                                    countryCode="EU"
                                                    style={{
                                                        width: '22px',
                                                        height: '22px',
                                                        position:'absolute',
                                                        maxWidth:'50px',
                                                        backgroundColor:'#003399'
                                                    }}
                                                    aria-label="United States"
                                                    svg
                                                />
                                            </div>
                                            <span>유럽</span>
                                        </li>
                                        <li onClick={() => redirectToLink('https://us.carhartt-wip.com/')}
                                            className={`py-4 pl-3 flex items-center gap-x-4 border-b cursor-pointer hover:bg-gray-50`}>
                                            <div className={`flex items-center justify-center rounded-full overflow-hidden wh-5 relative bg-white`}>
                                                <ReactCountryFlag
                                                    countryCode="US"
                                                    style={{
                                                        width: '26px',
                                                        height: '26px',
                                                        position:'absolute',
                                                        maxWidth:'50px',
                                                    }}
                                                    aria-label="United States"
                                                    svg
                                                />
                                            </div>
                                            <span>미국</span>
                                        </li>
                                        {/*<li onClick={() => redirectToLink('https://www.carhartt-wip.com.au/')}*/}
                                        {/*    className={`py-4 pl-3 flex items-center gap-x-4 border-b cursor-pointer hover:bg-gray-50`}>*/}
                                        {/*    <div className={`flex items-center justify-center rounded-full overflow-hidden wh-5 relative bg-white`}>*/}
                                        {/*        <ReactCountryFlag*/}
                                        {/*            countryCode="AU"*/}
                                        {/*            style={{*/}
                                        {/*                width: '28px',*/}
                                        {/*                height: '28px',*/}
                                        {/*                position:'absolute',*/}
                                        {/*                maxWidth:'50px',*/}
                                        {/*            }}*/}
                                        {/*            aria-label="United States"*/}
                                        {/*            svg*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*    <span>호주</span>*/}
                                        {/*</li>*/}
                                        <li onClick={() => redirectToLink('https://carhartt-wip.jp/')}
                                            className={`py-4 pl-3 flex items-center gap-x-4 border-b cursor-pointer hover:bg-gray-50`}>
                                            <div className={`flex items-center justify-center rounded-full overflow-hidden wh-5 relative bg-gray-100`}>
                                                <span style={{backgroundColor:'#bc002d'}} className={`wh-2 rounded-full`} />
                                            </div>
                                            <span>일본</span>
                                        </li>
                                        <li onClick={() => redirectToLink('https://www.carhartt-wip.com.my/')}
                                            className={`py-4 pl-3 flex items-center gap-x-4 border-b cursor-pointer hover:bg-gray-50`}>
                                            <div className={`flex items-center justify-center rounded-full overflow-hidden wh-5 relative bg-white`}>
                                                <ReactCountryFlag
                                                    countryCode="MY"
                                                    style={{
                                                        width: '28px',
                                                        height: '28px',
                                                        position:'absolute',
                                                        maxWidth:'50px',
                                                    }}
                                                    aria-label="United States"
                                                    svg
                                                />
                                            </div>
                                            <span>말레이시아</span>
                                        </li>
                                        <li onClick={() => redirectToLink('https://carhartt-wip.com.sg/')}
                                            className={`py-4 pl-3 flex items-center gap-x-4 border-b cursor-pointer hover:bg-gray-50`}>
                                            <div className={`flex items-center justify-center rounded-full overflow-hidden wh-5 relative bg-white`}>
                                                <SgFlag />
                                            </div>
                                            <span>싱가포르</span>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </>
                    }
                    <button
                        onClick={goBack}
                        className="place-content-center grid border-l px-4"
                    >
                        <CloseButton/>
                    </button>
                </div>
            </div>
            <div className={`bg-white flex flex-col mb-100 text-14`}>
                {/* 가변 카테고리 */}
                {categories.sort((a, b) => b.sort - a.sort).map((item, index) => (
                    <MobileCategoryItem category={item} key={index}/>
                ))}
                {/* 고정 카테고리 */}
                {exCategories.map((item, index) => (
                    <div key={index} onClick={() => {onClickContent(item.text); push(item.path)}} className="border-b py-4">
                        {item.text}
                    </div>
                ))}
            </div>
        </>
    );
};
